import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    loading: any;

    constructor(private loadingCtrl: LoadingController) {}

    // Create Loaader
    async create() {
        this.loading = await this.loadingCtrl.create({
            cssClass: 'loader'
        });

        this.loading.present();
    }

    async dismiss() {
        setTimeout(() => {
            this.loadingCtrl.getTop().then(
                v => v ? this.loadingCtrl.dismiss() : null
            );
        }, 500)
    }
}
